(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heartnoks-pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    let cleanup = () => {};
    const init = () => {
      cleanup();
      const bar = document.querySelector('[data-hn-sticky-bar]');
      const form = document.getElementById('MediatorProductHeroForm');
      const buybox = document.getElementById('hnx-buybox');
      const actions = form?.querySelector('.hnb__actions');
      const button = bar?.querySelector('button[type="submit"]');
      const price = bar?.querySelector('[data-hn-price]');
      if (!bar || !form || !buybox || !actions || !button || !price || !window.IntersectionObserver) return;

      const media = window.matchMedia('(max-width: 768px)');
      let stopMobile = () => {};
      const hide = () => {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.inert = true;
        if (document.body.classList.contains('hn-sticky-bar-visible')) document.body.classList.remove('hn-sticky-bar-visible');
        document.body.style.removeProperty('--hn-sticky-bar-height');
      };
      const setMode = () => {
        stopMobile();
        hide();
        if (!media.matches) return;

        let alive = true;
        let queued = false;
        let observed = false;
        const sync = () => {
          if (!alive || !media.matches) return;
          const primary = buybox.querySelector('[data-hn-price][data-hn-price-fragment="product-price"]');
          const submitter = actions.querySelector('button[type="submit"]:not([data-hnx-buy-now])');
          const variantId = form.elements.namedItem('id')?.value;
          const current = primary && primary.dataset.hnVariantId === variantId;
          if (current) {
            if (price.innerHTML !== primary.innerHTML) price.innerHTML = primary.innerHTML;
            ['hnVariantId', 'hnServerPrice', 'hnDisplayPrice', 'hnServerCompare', 'hnPriceState'].forEach(key => {
              if (primary.dataset[key] === undefined) delete price.dataset[key];
              else if (price.dataset[key] !== primary.dataset[key]) price.dataset[key] = primary.dataset[key];
            });
          }
          const pending = form.getAttribute('data-cart-pending') === 'true' || form.getAttribute('aria-busy') === 'true';
          const busy = Boolean(window.HeartnoksCartGate?.busy());
          button.disabled = !current || !submitter || submitter.disabled || submitter.getAttribute('aria-disabled') === 'true' || pending || busy;
          button.setAttribute('aria-busy', String(pending || busy));
          const label = pending || busy ? bar.dataset.hnPendingLabel : submitter?.textContent.trim();
          if (label && button.textContent !== label) button.textContent = label;
          const above = observed && actions.getBoundingClientRect().bottom <= 0;
          const visible = above && current && !document.body.classList.contains('hn-cart-drawer-open');
          if (visible) {
            document.body.style.setProperty('--hn-sticky-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
            if (!document.body.classList.contains('hn-sticky-bar-visible')) document.body.classList.add('hn-sticky-bar-visible');
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
            bar.inert = false;
          } else hide();
        };
        const schedule = () => {
          if (queued) return;
          queued = true;
          queueMicrotask(() => { queued = false; sync(); });
        };
        const intersection = new IntersectionObserver(() => {
          observed = true;
          sync();
        }, { threshold: [0, 1] });
        intersection.observe(actions);
        const contentObserver = new MutationObserver(schedule);
        contentObserver.observe(buybox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'data-cart-pending', 'aria-busy', 'value', 'data-hn-variant-id', 'data-hn-server-price', 'data-hn-display-price', 'data-hn-server-compare', 'data-hn-price-state'] });
        const drawerObserver = new MutationObserver(schedule);
        drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        const resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
        resize?.observe(bar);
        form.addEventListener('change', schedule);
        form.addEventListener('input', schedule);
        document.addEventListener('hn:cart:gate', schedule);
        window.addEventListener('resize', schedule);
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('pageshow', schedule);
        sync();
        stopMobile = () => {
          alive = false;
          intersection.disconnect();
          contentObserver.disconnect();
          drawerObserver.disconnect();
          resize?.disconnect();
          form.removeEventListener('change', schedule);
          form.removeEventListener('input', schedule);
          document.removeEventListener('hn:cart:gate', schedule);
          window.removeEventListener('resize', schedule);
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('pageshow', schedule);
        };
      };
      media.addEventListener('change', setMode);
      setMode();
      cleanup = () => { stopMobile(); media.removeEventListener('change', setMode); hide(); };
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.querySelector?.('[data-hn-sticky-bar]')) cleanup();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heartnoks-promotion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.heartnoksPromotion) return;
    const campaigns = [
      { start: Date.parse('2026-10-16T00:00:00-07:00'), end: Date.parse('2026-10-19T00:00:00-07:00'), halloween: false, price: 14999 },
      { start: Date.parse('2026-10-23T00:00:00-07:00'), end: Date.parse('2026-10-26T00:00:00-07:00'), halloween: false, price: 14999 },
      { start: Date.parse('2026-10-30T00:00:00-07:00'), end: Date.parse('2026-11-02T00:00:00-08:00'), halloween: true, price: 14999 },
      { start: Date.parse('2026-11-23T00:00:00-08:00'), end: Date.parse('2026-11-30T00:00:00-08:00'), kind: 'bf', price: 14999 },
      { start: Date.parse('2026-11-30T00:00:00-08:00'), end: Date.parse('2026-12-03T00:00:00-08:00'), kind: 'cm', price: 15999 }
    ];
    const weekdayStart = Date.parse('2026-10-12T00:00:00-07:00');
    // 2026-10-28: Nov 2 is still a boundary (first-order offer becomes $15), so server prices/copy refresh then.
    const offerSwitch = Date.parse('2026-11-02T00:00:00-08:00');
    const boundaries = [weekdayStart, offerSwitch, ...campaigns.flatMap(c => [c.start, c.end])];
    const phaseAt = now => String(boundaries.filter(boundary => now >= boundary).length);
    const campaignAt = now => campaigns.find(c => now >= c.start && now < c.end);
    let phase, timer;
    const priceSelector = '[data-hn-price-fragment]';
    const priceRetryDelays = [0, 2000, 8000, 30000, 90000];
    let priceTicket = 0;
    let priceRetryTimer;
    let priceController;
    let priceFragmentSequence = 0;
    let lastPriceRefresh = -Infinity;
    let priceBatch;
    let deferredPriceBoundary = false;
    // Fetch server-rendered money/Save/badges in this locale and currency. Never infer a future price from the clock.
    const priceGroups = (fragments, sectionId) => {
      const groups = new Map();
      fragments.forEach(fragment => {
        const role = fragment.dataset.hnPriceFragment;
        const variantId = fragment.dataset.hnVariantId;
        if (!role || !/^\d+$/.test(variantId || '')) return;
        const key = role + ':' + variantId;
        if (!groups.has(key)) groups.set(key, []);
        const group = groups.get(key);
        if (sectionId) {
          fragment.dataset.hnPriceKey = sectionId + ':' + key + ':' + group.length;
          if (!fragment.id) {
            let id;
            do { id = 'hn-live-price-' + (++priceFragmentSequence); } while (document.getElementById(id));
            fragment.id = id;
          }
        }
        group.push(fragment);
      });
      return groups;
    };
    const priceSections = () => {
      const sections = new Map();
      document.querySelectorAll(priceSelector).forEach(fragment => {
        const section = fragment.closest('[id^="shopify-section-"]');
        if (!section?.id || !fragment.isConnected) return;
        const id = section.id.slice('shopify-section-'.length);
        if (!id) return;
        if (!sections.has(id)) {
          // Shopify accepts at most five section IDs. Leave any additional section's real old price untouched.
          if (sections.size >= 5) { fragment.dataset.hnPriceState = 'stale'; return; }
          sections.set(id, []);
        }
        sections.get(id).push(fragment);
      });
      return Array.from(sections, ([id, fragments]) => ({ id, fragments, groups: priceGroups(fragments, id) }));
    };
    const safePriceFragment = fragment => {
      if (!/^\d+$/.test(fragment.dataset.hnServerPrice || '') || !/^\d+$/.test(fragment.dataset.hnServerCompare || '') || !/^\d+$/.test(fragment.dataset.hnDisplayPrice || fragment.dataset.hnServerPrice || '')) return false;
      const allowed = new Set(['SPAN', 'S', 'STRONG', 'DIV', 'P', 'SMALL']);
      return Array.from(fragment.querySelectorAll('*')).every(child => allowed.has(child.tagName) &&
        !Array.from(child.attributes).some(attribute => /^on/i.test(attribute.name) || ['href', 'src', 'srcdoc', 'action'].includes(attribute.name)));
    };
    const applyPriceSection = (section, html, baseline) => {
      if (typeof html !== 'string' || !html) return { valid: false, changed: false };
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const sources = priceGroups(Array.from(parsed.querySelectorAll(priceSelector)));
      const updates = [];
      for (const [key, targets] of section.groups) {
        const matches = sources.get(key);
        if (!matches || matches.length !== targets.length) return { valid: false, changed: false };
        for (let index = 0; index < targets.length; index++) {
          const target = targets[index], source = matches[index];
          if (!target.isConnected || target.closest('[id^="shopify-section-"]')?.id !== 'shopify-section-' + section.id ||
              target.dataset.hnVariantId !== source.dataset.hnVariantId || target.dataset.hnPriceFragment !== source.dataset.hnPriceFragment ||
              !safePriceFragment(source)) return { valid: false, changed: false };
          updates.push({ target, source });
        }
      }
      if (!updates.length) return { valid: false, changed: false };
      let changed = true;
      updates.forEach(({ target, source }) => {
        const previous = baseline.get(target);
        changed = changed && Boolean(previous && (previous.price !== source.dataset.hnServerPrice || previous.compare !== source.dataset.hnServerCompare || previous.display !== (source.dataset.hnDisplayPrice || source.dataset.hnServerPrice)));
        // Keep the existing fragment, listeners/focus outside it, forms, variant inputs and warranty/cart state intact.
        if (target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
        target.dataset.hnServerPrice = source.dataset.hnServerPrice;
        target.dataset.hnDisplayPrice = source.dataset.hnDisplayPrice || source.dataset.hnServerPrice;
        target.dataset.hnServerCompare = source.dataset.hnServerCompare;
        target.dataset.hnPriceState = 'synced';
      });
      sync();
      return { valid: true, changed };
    };
    const requestPriceAttempt = async batch => {
      if (batch.ticket !== priceTicket) return;
      if (document.hidden) { deferredPriceBoundary = deferredPriceBoundary || batch.boundary; priceBatch = undefined; return; }
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      priceController = controller;
      let timeout;
      let valid = false, changed = false;
      let failedSections = batch.sections;
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', batch.sections.map(section => section.id).join(','));
        const deadline = new Promise((_, reject) => {
          timeout = setTimeout(() => { controller?.abort(); reject(new Error('Price read timed out')); }, 8000);
        });
        const response = await Promise.race([fetch(url.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller?.signal }), deadline]);
        if (!response.ok) throw new Error('Price read failed');
        const payload = await Promise.race([response.json(), deadline]);
        if (batch.ticket !== priceTicket || phaseAt(Date.now()) !== batch.phase) return;
        const results = batch.sections.map(section => applyPriceSection(section, payload?.[section.id], batch.baseline));
        valid = results.every(result => result.valid);
        changed = results.every(result => result.changed);
        failedSections = batch.sections.filter((_, index) => !results[index].valid);
      } catch (_) {
        // The backend may still be at the old stage or temporarily unreadable. Keep the last actual server price.
      } finally {
        clearTimeout(timeout);
        if (batch.ticket === priceTicket) priceController = undefined;
      }
      if (batch.ticket !== priceTicket || phaseAt(Date.now()) !== batch.phase) return;
      failedSections.forEach(section => section.fragments.forEach(fragment => { if (fragment.isConnected) fragment.dataset.hnPriceState = 'stale'; }));
      // At a boundary, an unchanged price is not proof the native scheduled price has applied. Retry within a finite window.
      if (valid && (!batch.boundary || changed)) { priceBatch = undefined; return; }
      batch.attempt++;
      const limit = batch.boundary ? priceRetryDelays.length : 3;
      if (batch.attempt >= limit) { priceBatch = undefined; return; }
      const delay = Math.max(0, batch.startedAt + priceRetryDelays[batch.attempt] - Date.now());
      priceRetryTimer = setTimeout(() => requestPriceAttempt(batch), delay);
    };
    const refreshServerPrices = boundary => {
      if (boundary) deferredPriceBoundary = true;
      if (!boundary && (priceBatch || Date.now() - lastPriceRefresh < 30000)) return;
      clearTimeout(priceRetryTimer);
      priceController?.abort();
      const ticket = ++priceTicket;
      const sections = priceSections();
      priceBatch = undefined;
      if (!sections.length || document.hidden) return;
      const baseline = new Map();
      sections.forEach(section => section.fragments.forEach(fragment => {
        baseline.set(fragment, { price: fragment.dataset.hnServerPrice, compare: fragment.dataset.hnServerCompare, display: fragment.dataset.hnDisplayPrice || fragment.dataset.hnServerPrice });
        fragment.dataset.hnPriceState = 'pending';
      }));
      lastPriceRefresh = Date.now();
      priceBatch = { ticket, sections, baseline, phase: phaseAt(Date.now()), startedAt: Date.now(), attempt: 0, boundary: boundary || deferredPriceBoundary };
      deferredPriceBoundary = false;
      requestPriceAttempt(priceBatch);
    };
    const nodePrice = node => {
      const id = node.dataset.hnOfferVariant;
      const selector = '[data-hn-price-fragment][data-hn-variant-id="' + id + '"]';
      const fragment = node.querySelector(selector) || document.querySelector(selector);
      return Number(fragment?.dataset.hnDisplayPrice || fragment?.dataset.hnServerPrice);
    };
    const activeFor = (node, campaign) => Boolean(campaign && node.dataset.hnOfferCurrency === 'USD' && nodePrice(node) === campaign.price);
    const endFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: 'America/Los_Angeles', weekday: 'long', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    const sync = () => {
      clearTimeout(timer);
      const now = Date.now(), nextPhase = phaseAt(now), campaign = campaignAt(now);
      if (phase !== nextPhase) {
        const initialized = phase !== undefined;
        phase = nextPhase;
        if (initialized) refreshServerPrices(true);
      }
      const config = document.querySelector('[data-hn-offer-config]');
      let anyActive = false;
      document.querySelectorAll('[data-hn-promotion]').forEach(node => {
        const active = activeFor(node, campaign);
        anyActive = anyActive || active;
        node.dataset.hnFlashActive = String(active);
        node.querySelectorAll('[data-hn-event-countdown], [data-hn-hero-flash]').forEach(part => { part.hidden = !active; });
        node.querySelectorAll('[data-hn-regular-announcement], [data-hn-hero-regular]').forEach(part => { part.hidden = active; });
        if (!active) return;
        const title = campaign.halloween ? config?.dataset.hnHalloweenTitle : campaign.kind === 'bf' ? config?.dataset.hnBfTitle : campaign.kind === 'cm' ? config?.dataset.hnCmTitle : config?.dataset.hnEventTitle;
        if (title) node.querySelectorAll('[data-hn-event-title]').forEach(part => { part.textContent = title; });
        const remaining = Math.max(0, Math.ceil((campaign.end - now) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        node.querySelectorAll('[data-hn-time]').forEach(digit => { digit.textContent = String(values[digit.dataset.hnTime]).padStart(2, '0'); });
        node.querySelectorAll('[data-hn-countdown-date]').forEach(part => { part.textContent = (config?.dataset.hnEndsLabel || '') + ' ' + endFormat.format(campaign.end - 1000); });
      });
      document.documentElement.dataset.hnFlashActive = String(anyActive);
      window.heartnoksPriceReaders?.sync();
      const boundary = boundaries.find(value => value > now);
      timer = setTimeout(sync, Math.max(50, anyActive ? Math.min(1000, campaign.end - now) : boundary ? Math.min(30000, boundary - now) : 30000));
    };
    const init = () => { sync(); };
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) { sync(); refreshServerPrices(false); }
      else {
        deferredPriceBoundary = deferredPriceBoundary || Boolean(priceBatch?.boundary);
        if (priceBatch) lastPriceRefresh = -Infinity;
        clearTimeout(priceRetryTimer);
        priceController?.abort();
        priceController = undefined;
        priceTicket++;
        priceBatch = undefined;
      }
    });
    window.addEventListener('pageshow', event => { init(); if (event.persisted) refreshServerPrices(false); });
    document.addEventListener('shopify:section:load', init);
    window.heartnoksPromotion = { refresh: init, memberActive: () => Boolean(campaignAt(Date.now()) && Array.from(document.querySelectorAll('[data-hn-promotion]')).some(node => activeFor(node, campaignAt(Date.now())))) };
    init();
    setInterval(() => { if (!document.hidden) refreshServerPrices(false); }, 60000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heartnoks-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.heartnoksWelcome) return;
    const storageKey = 'heartnoks-welcome';
    const appliedKey = 'heartnoks-applied-code';
    const formId = 'HnWelcomeForm';
    const quietDays = 7;
    const scrollShare = 0.35;
    const dwellMs = 20000;
    // Shopify marks every customer form as posted; only this form's return may apply its code.
    const returned = location.hash === '#' + formId;
    const find = () => document.querySelector('[data-hn-welcome]');
    const findSuccess = () => document.querySelector('[data-hn-welcome-success]');
    const read = () => { try { return JSON.parse(localStorage.getItem(storageKey)) || {}; } catch (_) { return {}; } };
    const write = patch => { try { localStorage.setItem(storageKey, JSON.stringify(Object.assign(read(), patch))); } catch (_) { /* Private mode: the dialog simply may show again. */ } };
    const memberWindow = () => {
      const dialog = find();
      const start = Number(dialog?.dataset.hnMemberStart) || Date.parse('2026-10-06T07:01:00Z');
      const end = Number(dialog?.dataset.hnMemberEnd) || Date.parse('2026-10-08T07:00:00Z');
      return { start, end };
    };
    const memberPhase = () => {
      const { start, end } = memberWindow();
      const now = Date.now();
      return now < start ? 'before' : now < end ? 'member' : 'after';
    };
    const flashActive = () => memberPhase() === 'member';
    const codeBlocked = code => String(code).toUpperCase() === 'WELCOME10' && flashActive();
    const cartRoot = () => window.Shopify?.routes?.root || '/';
    let previousPhase = memberPhase();
    let toastGeneration = 0;
    let successGeneration = 0;
    let appliedTimer;
    let boundaryTimer;
    let dwellTimer;
    const systemClosures = new WeakSet();
    const hideApplied = () => {
      toastGeneration++;
      clearTimeout(appliedTimer);
      const toast = document.querySelector('[data-hn-applied]');
      if (toast) toast.hidden = true;
    };
    const setSuccessState = state => {
      const success = findSuccess();
      if (!success) return;
      const applied = state === 'applied';
      const hadFocus = success.contains(document.activeElement);
      success.querySelectorAll('[data-hn-welcome-before]').forEach(part => { part.hidden = applied; });
      success.querySelectorAll('[data-hn-welcome-after]').forEach(part => { part.hidden = !applied; });
      const feedback = success.querySelector('[data-hn-welcome-feedback]');
      if (feedback) {
        feedback.hidden = !state || applied;
        feedback.querySelectorAll('[data-hn-welcome-feedback-state]').forEach(part => { part.hidden = part.dataset.hnWelcomeFeedbackState !== state; });
      }
      const next = applied && success.querySelector('button[data-hn-welcome-after]');
      if (hadFocus && next) next.focus();
    };
    // A native close event is queued by browsers. Remember its dialog until that event arrives.
    const closeForMember = () => {
      if (!flashActive()) return false;
      armed = false;
      clearTimeout(dwellTimer);
      successGeneration++;
      hideApplied();
      setSuccessState(null);
      const dialog = find();
      if (dialog) {
        dialog.hidden = true;
        if (dialog.open) {
          systemClosures.add(dialog);
          dialog.close();
        }
      }
      return true;
    };
    const scheduleBoundary = () => {
      clearTimeout(boundaryTimer);
      const { start, end } = memberWindow();
      const now = Date.now();
      const next = now < start ? start : now < end ? end : null;
      if (next !== null) boundaryTimer = setTimeout(syncPhase, Math.max(1, Math.min(2147483647, next - now)));
    };
    // Called by the promotion clock and on user/page activity. No cart mutation or automatic replay.
    const syncPhase = () => {
      const phase = memberPhase();
      const active = phase === 'member';
      if (phase !== previousPhase) {
        previousPhase = phase;
        successGeneration++;
        hideApplied();
        setSuccessState(null);
        if (!active) {
          armed = mayAutoOpen();
          scheduleDwell();
        }
      }
      const dialog = find();
      if (active) {
        closeForMember();
        try {
          if (String(sessionStorage.getItem(appliedKey)).toUpperCase() === 'WELCOME10') sessionStorage.removeItem(appliedKey);
        } catch (_) { /* Private mode. */ }
      } else if (dialog) dialog.hidden = false;
      scheduleBoundary();
      return active;
    };
    // An empty cart or unreadable response provides no proof that a discount is usable.
    const stateFromResponse = async (response, code) => {
      if (!response?.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0 || (cart.discount_codes != null && !Array.isArray(cart.discount_codes))) throw new Error('Invalid cart response');
      if (!cart.item_count) return 'unconfirmed';
      const entry = (cart.discount_codes || []).find(d => String(d?.code).toUpperCase() === String(code).toUpperCase());
      return entry?.applicable === true ? 'applied' : 'rejected';
    };
    // Reopening only reads the cart; it never reapplies a code or replays the signup POST.
    const refreshState = async () => {
      syncPhase();
      const code = findSuccess()?.dataset.hnWelcomeCode;
      const generation = ++successGeneration;
      setSuccessState(null);
      if (!code || codeBlocked(code)) return 'blocked';
      setSuccessState('checking');
      let state;
      try {
        state = await stateFromResponse(await fetch(cartRoot() + 'cart.js', { headers: { accept: 'application/json' } }), code);
      } catch (_) { state = 'error'; }
      syncPhase();
      if (generation !== successGeneration || codeBlocked(code)) return 'stale';
      setSuccessState(state);
      return state;
    };
    const open = (focusEmail, revalidate = true) => {
      const dialog = find();
      if (syncPhase() || !dialog || typeof dialog.showModal !== 'function') return false;
      if (!dialog.open) dialog.showModal();
      if (revalidate && findSuccess()) refreshState();
      // Only a visitor-initiated open focuses the email field; see flash popup (hCaptcha).
      if (focusEmail) dialog.querySelector('input[type="email"]')?.focus();
      return true;
    };
    // Wait while Add to Cart is pending: the cart drawer opens only after the request returns.
    const busy = () => Boolean(document.querySelector('dialog[open], [data-cart-drawer]:not([hidden]), form[data-cart-pending], shopify-chat[open]'));
    const mayAutoOpen = () => {
      const dialog = find();
      const state = read();
      if (!dialog || dialog.hasAttribute('data-hn-welcome-known') || state.subscribed || flashActive()) return false;
      if (state.dismissedAt && Date.now() - state.dismissedAt < quietDays * 86400000) return false;
      return !/^\/(cart|checkouts?|account)(\/|$)/.test(location.pathname);
    };
    let armed = mayAutoOpen();
    const scheduleDwell = () => {
      clearTimeout(dwellTimer);
      if (armed) dwellTimer = setTimeout(autoOpen, dwellMs);
    };
    const autoOpen = () => {
      syncPhase();
      if (!armed || document.hidden) return;
      if (document.body.classList.contains('template-index') && matchMedia('(max-width: 700px)').matches) return;
      if (!mayAutoOpen()) { armed = false; return; }
      if (busy()) return;
      armed = false;
      clearTimeout(dwellTimer);
      open(false);
    };
    const onScroll = () => {
      const range = document.documentElement.scrollHeight - window.innerHeight;
      if (range > 0 && window.scrollY / range >= scrollShare) autoOpen();
    };
    const cancelSuccess = () => { successGeneration++; setSuccessState(null); };
    document.addEventListener('click', event => {
      const dialog = find();
      if (!dialog?.open) return;
      if (event.target === dialog || event.target.closest?.('[data-hn-welcome-close]')) {
        cancelSuccess();
        dialog.close();
      }
    });
    document.addEventListener('close', event => {
      if (!event.target.matches?.('[data-hn-welcome]')) return;
      if (systemClosures.has(event.target)) {
        systemClosures.delete(event.target);
        return;
      }
      cancelSuccess();
      armed = false;
      clearTimeout(dwellTimer);
      if (!read().subscribed) write({ dismissedAt: Date.now() });
    }, true);
    document.addEventListener('cancel', event => {
      if (event.target.matches?.('[data-hn-welcome]')) cancelSuccess();
    }, true);
    // Install once even on a first visit during Member Days, so eligibility can resume at its end.
    window.addEventListener('scroll', onScroll, { passive: true });
    // Back from the customer form post: reopen the result step and tidy the address bar.
    if (returned) {
      const dialog = find();
      if (dialog?.querySelector('[data-hn-welcome-success]')) write({ subscribed: true });
      if (dialog?.querySelector('[data-hn-welcome-success], [data-hn-welcome-error]')) {
        open(true, false);
        const url = new URL(location.href);
        url.hash = '';
        ['customer_posted', 'form_type', 'contact[tags]', 'contact[email]'].forEach(name => url.searchParams.delete(name));
        history.replaceState(history.state, '', url);
      }
    }
    document.addEventListener('click', event => {
      if (event.target.closest?.('[data-hn-applied-close]')) { hideApplied(); return; }
      const link = event.target.closest?.('a[href*="/discount/"]');
      if (!link) return;
      syncPhase();
      const href = link.getAttribute('href') || '';
      const encoded = (href.split('/discount/')[1] || '').split(/[?#]/)[0];
      let code;
      try { code = decodeURIComponent(encoded); } catch (_) { return; }
      if (codeBlocked(code)) { event.preventDefault(); return; }
      if (code) { try { sessionStorage.setItem(appliedKey, code); } catch (_) { /* Private mode: skip the return toast. */ } }
    });
    const showApplied = async () => {
      syncPhase();
      let code = null;
      try { code = sessionStorage.getItem(appliedKey); if (code) sessionStorage.removeItem(appliedKey); } catch (_) { return; }
      const toast = document.querySelector('[data-hn-applied]');
      if (!code || !toast || codeBlocked(code)) return;
      hideApplied();
      const generation = toastGeneration;
      let state;
      try {
        state = await stateFromResponse(await fetch(cartRoot() + 'cart.js', { headers: { accept: 'application/json' } }), code);
      } catch (_) { state = 'error'; }
      syncPhase();
      if (generation !== toastGeneration || codeBlocked(code)) return;
      toast.querySelector('[data-hn-applied-code]').textContent = code;
      toast.querySelectorAll('[data-hn-applied-state]').forEach(part => { part.hidden = part.dataset.hnAppliedState !== state; });
      ['rejected', 'unconfirmed', 'error'].forEach(name => toast.classList.toggle('hn-applied--' + name, state === name));
      toast.hidden = false;
      appliedTimer = setTimeout(hideApplied, 7000);
    };
    // A signup return retains its single original auto-apply request. Every recovery path is GET only.
    const autoApply = async () => {
      syncPhase();
      const code = findSuccess()?.dataset.hnWelcomeCode;
      if (!returned || !code || codeBlocked(code)) return;
      const generation = ++successGeneration;
      setSuccessState('checking');
      let state;
      try {
        const response = await fetch(cartRoot() + 'cart/update.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
        state = await stateFromResponse(response, code);
      } catch (_) { state = 'error'; }
      syncPhase();
      if (generation !== successGeneration || codeBlocked(code)) return;
      setSuccessState(state);
    };
    document.addEventListener('submit', event => {
      if (event.target.id === formId && syncPhase()) event.preventDefault();
    }, true);
    window.heartnoksWelcome = {
      open: () => open(true),
      openForShop: () => {
        if (syncPhase() || !mayAutoOpen() || busy()) return false;
        const opened = open(false);
        if (opened) armed = false;
        return opened;
      },
      closeForMember,
      syncPhase,
      refreshState
    };
    window.addEventListener('pageshow', event => {
      syncPhase();
      // Initial pageshow must not cancel the signup POST or return-toast GET already started above.
      // A bfcache restoration needs new evidence because its old success state may be stale.
      if (!event.persisted) return;
      hideApplied();
      showApplied();
      if (find()?.open && findSuccess()) refreshState();
    });
    document.addEventListener('heartnoks:promotion-phase', syncPhase);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) syncPhase(); });
    document.addEventListener('shopify:section:load', syncPhase);
    syncPhase();
    scheduleDwell();
    showApplied();
    autoApply();
  })();
  } catch(e) { console.error(e); }
})();

})();
